//Serviços
import { Axios } from "../../service/serviceBasic";
import {
  converterListActionForListReduceDropdownDadosIniciaisPFDocumento,
  converterListActionForListReduceDropdownDadosIniciaisPFOrgaoEmissor,
  converterObjActionForObjReduceDadosIniciaisPF,
  makeDate,
  removeMask,
} from "../../helper/converter";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import { SET_MESSAGE_CONCLUSAO } from "./../conclusao/types";

//Tipos
import {
  SET_DADOS_INICIAIAS_PF_DOCUMENTO,
  LOADING_DADOS_INICIAIAS_PF_DOCUMENTO,
  ERROR_DADOS_INICIAIAS_PF_DOCUMENTO,
  SET_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  LOADING_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  ERROR_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  HANDLER_CHANGE_DADOS_INICIAIS_PF_ORGAOEMISSOR,
  CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM,
  HANDLER_CHANGE_DADOS_INICIAIS_PF_DOCUMENTO,
  HANDLER_CHANGE_DADOS_INICIAIS_PF_PAIS,
  SET_DADOS_INICIAIAS_PF_PAIS,
  LOADING_DADOS_INICIAIAS_PF_PAIS,
  ERROR_DADOS_INICIAIAS_PF_PAIS,
  LOADING_DADOS_INICIAIAS_PF_CPF,
  SET_DADOS_INICIAIAS_PF_CPF,
  ERROR_DADOS_INICIAIAS_PF_CPF,
  LOADING_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
  ERROR_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
  LOADING_DADOS_INICIAIAS_PF_NOME_GERENTE,
  ERROR_DADOS_INICIAIAS_PF_NOME_GERENTE,
  SET_CODIGO_GERENTE_VIA_LINK,
  SET_ID_DDIPAIS_DADOS_INICIAIS_PF,
} from "./types";

const loadingListDadosIniciaisPFDocumentoAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PF_DOCUMENTO,
  payload: flag,
});
const setListDadosIniciaisPFDocumentoAction = (list) => ({
  type: SET_DADOS_INICIAIAS_PF_DOCUMENTO,
  payload: list,
});
const setErrorListDadosIniciaisPFDocumento = (message) => ({
  type: ERROR_DADOS_INICIAIAS_PF_DOCUMENTO,
  payload: message,
});

export const getListDadosIniciaisPFDocumentoAction = (tipoPessoaValue) => (
  dispatch,
  getState
) => {
  let { tipoCadastroReducer } = getState();

  let tipoPessoaId = (() => {
    switch (tipoPessoaValue || tipoCadastroReducer.tipoPessoaValue) {
      case "PessoaFisica": return 1;
      case "PessoaJuridica": return 2;
      case "PessoaEstrangeira": return 3;
      default:
    }
  })();

  dispatch(loadingListDadosIniciaisPFDocumentoAction(true));
  return Axios.post("v1/cliente/tipodocumento/list", {
    Classe: "I",
    IdTipoPessoa: tipoPessoaId,
  })
    .then((response) => {
      let listResponse = converterListActionForListReduceDropdownDadosIniciaisPFDocumento(
        response.data
      );
      dispatch(setListDadosIniciaisPFDocumentoAction(listResponse));
    })
    .catch((error) => {
      toast.warn("Tente novamente, ou dirija-se a uma loja da B&T Câmbio", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "ui-alert-toast",
      });

      dispatch(setErrorListDadosIniciaisPFDocumento(error.message));
    })
    .finally(() => {
      dispatch(loadingListDadosIniciaisPFDocumentoAction(false));
    });
};

const loadingListDadosIniciaisPFOrgaoEmissorAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  payload: flag,
});
const setListDadosIniciaisPFOrgaoEmissorAction = (list) => ({
  type: SET_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  payload: list,
});
const setErrorListDadosIniciaisPFOrgaoEmissor = (message) => ({
  type: ERROR_DADOS_INICIAIAS_PF_ORGAOEMISSOR,
  payload: message,
});
export const handleChangeDadosIniciaisPFOrgaoEmissor = (event) => ({
  type: HANDLER_CHANGE_DADOS_INICIAIS_PF_ORGAOEMISSOR,
  payload: event.value,
});

export const getListDadosIniciaisPFOrgaoEmissorAction = () => (
  dispatch,
  getState
) => {
  dispatch(loadingListDadosIniciaisPFOrgaoEmissorAction(true));
  return Axios.post("v2/basico/orgaoemissor/list", { Classe: "I" })
    .then((response) => {
      let listResponse = converterListActionForListReduceDropdownDadosIniciaisPFOrgaoEmissor(
        response.data
      );
      dispatch(setListDadosIniciaisPFOrgaoEmissorAction(listResponse));
    })
    .catch((error) => {
      toast.warn("Tente novamente, ou dirija-se a uma loja da B&T Câmbio", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "ui-alert-toast",
      });

      dispatch(setErrorListDadosIniciaisPFOrgaoEmissor(error.message));
    })
    .finally(() => {
      dispatch(loadingListDadosIniciaisPFOrgaoEmissorAction(false));
    });
};

export const changeDadosIniciaisPFValueForm = (name, value, idPaisDDI = 0) => (
  dispatch,
  getState
) => {
  let { dadosIniciaisPFReducer } = getState();
  let formPFValues = dadosIniciaisPFReducer.formPF;

  formPFValues[name] = value;

  dispatch({
    type: CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM,
    payload: formPFValues,
  });
};

export const setIdDDIPaisDadosIniciaisPF = (id) => dispatch => {
  dispatch({
    type: SET_ID_DDIPAIS_DADOS_INICIAIS_PF,
    payload: id,
  }); 
}

export const handleChangeDadosIniciaisPFDocumento = (event) => ({
  type: HANDLER_CHANGE_DADOS_INICIAIS_PF_DOCUMENTO,
  payload: event.value,
});

export const handleChangeTypeaheadDadosIniciaisPais = (event) => ({
  type: HANDLER_CHANGE_DADOS_INICIAIS_PF_PAIS,
  payload: event.value,
});

export const getListDadosIniciasPFPaisAction = () => (dispatch) => {
  dispatch(loadingListDadosIniciaisPaisAction(true));
  return Axios.post("v1/basico/pais/list")
    .then((response) => {
      dispatch(setListDadosIniciaisPaisAction(response.data));
    })
    .catch((error) => {
      dispatch(setErrorListDadosIniciaisPaisAction(error.message));
    })
    .finally(() => {
      dispatch(loadingListDadosIniciaisPaisAction(false));
    });
};

export const resetDadosIniciaisPF_NomeGerenteAction = () => (
  dispatch,
  getState
) => {
  let { dadosIniciaisPFReducer } = getState();
  let formPFValues = dadosIniciaisPFReducer.formPF;

  formPFValues["dadosIniciais_nomeGerente"] = "";
  dispatch({
    type: CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM,
    payload: formPFValues,
  });
};

export const getDadosIniciaisPFGerenteAction = (value, query = false) => (
  dispatch,
  getState
) => {
  let { dadosIniciaisPFReducer } = getState();
  let formPFValues = dadosIniciaisPFReducer.formPF;

  let request = {
    IdGerente: value,
  };

  dispatch(loadingDadosIniciaisCodigoGerenteAction(true));
  return Axios.post("v1/basico/gerente/obterDadosGerente", request)
    .then((response) => {
      formPFValues["dadosIniciais_nomeGerente"] = response.data.Nome;
      dispatch({
        type: CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM,
        payload: formPFValues,
      });
      if (query) {
        dispatch({
          type: SET_CODIGO_GERENTE_VIA_LINK,
          payload: true,
        });
      }
      dispatch(setErrorDadosIniciaisCodigoGerenteAction(""));
    })
    .catch((error) => {
      dispatch(setErrorDadosIniciaisCodigoGerenteAction(error.message));
      dispatch(resetDadosIniciaisPF_NomeGerenteAction());
    })
    .finally(() => {
      dispatch(loadingDadosIniciaisCodigoGerenteAction(false));
    });
};

const loadingDadosIniciaisCodigoGerenteAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
  payload: flag,
});
const setErrorDadosIniciaisCodigoGerenteAction = (message) => ({
  type: ERROR_DADOS_INICIAIAS_PF_CODIGO_GERENTE,
  payload: message,
});

const loadingDadosIniciaisNomeGerenteAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PF_NOME_GERENTE,
  payload: flag,
});
const setErrorDadosIniciaisNomeGerenteAction = (message) => ({
  type: ERROR_DADOS_INICIAIAS_PF_NOME_GERENTE,
  payload: message,
});

const loadingListDadosIniciaisPaisAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PF_PAIS,
  payload: flag,
});
const setListDadosIniciaisPaisAction = (list) => ({
  type: SET_DADOS_INICIAIAS_PF_PAIS,
  payload: list,
});
const setErrorListDadosIniciaisPaisAction = (message) => ({
  type: ERROR_DADOS_INICIAIAS_PF_PAIS,
  payload: message,
});

const loadingDadosIniciaisExisteCpfAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PF_CPF,
  payload: flag,
});
const seDadosIniciaisExisteCpfAction = (existe) => ({
  type: SET_DADOS_INICIAIAS_PF_CPF,
  payload: existe,
});
const setErrorDadosIniciaisExisteCpf = (message) => ({
  type: ERROR_DADOS_INICIAIAS_PF_CPF,
  payload: message,
});

const seDadosIniciaisConclusaoCpfAction = (message) => ({
  type: SET_MESSAGE_CONCLUSAO,
  payload: {
    icon: "fa-cicle",
    title: "O CPF informado já possui cadastro conosco.",
    discription:
      "Caso deseje atualizar seu cadastro clique aqui. Para esclarecer dúvidas, enviar e-mail para cadastro@btcorretora.com.br.",
  },
});

export const getDadosIniciaisExisteCpfAction = (
  dataNascimento,
  dadosIniciais_cpf
) => (dispatch, getState) => {
  let { tipoCadastroReducer } = getState();
  let tipoPessoaId = 0;
  switch (tipoCadastroReducer.tipoPessoaValue) {
    case "PessoaFisica":
      tipoPessoaId = 1;
      break;
    case "PessoaJuridica":
      tipoPessoaId = 2;
      break;
    case "PessoaEstrangeira":
      tipoPessoaId = 3;
      break;
    default:
  }

  if (tipoPessoaId !== 3) {
    dataNascimento = makeDate(dataNascimento);
    dadosIniciais_cpf = removeMask(dadosIniciais_cpf);

    // let resultConverter = converterObjActionForObjReduceDadosIniciaisPF(
    //   dataNascimento,
    //   dadosIniciais_cpf,
    //   tipoPessoaId
    // );

    dispatch(loadingDadosIniciaisExisteCpfAction(true));
    return Axios.post("v2/basico/pessoa/verificaCadastroPF", {Cpf: dadosIniciais_cpf})
      .then(({ data }) => {
        dispatch(seDadosIniciaisExisteCpfAction(data.Existe));
      })
      .catch((error) => {
        dispatch(setErrorDadosIniciaisExisteCpf(error.message));
      })
      .finally(() => {
        dispatch(loadingDadosIniciaisExisteCpfAction(false));
      });
  }
};
